module.exports = __webpack_public_path__ + "static/img/rescue_sys_1.bbd7c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rescue_sys_1.jpg
// module id = 1/W8
// module chunks = 1